
import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import MetalEstimationForm from "@/components/MetalEstimationForm";
import HeroSection from "@/components/HeroSection";

const EstimationMetaux = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <SEO 
        title="Estimation de vos métaux et ferrailles - Groupe Fabre Environnement"
        description="Demandez une estimation gratuite pour la reprise de vos métaux et ferrailles. Le Groupe Fabre vous propose les meilleurs prix du marché pour vos matériaux recyclables."
        canonical="/estimation-metaux"
      />
      <Navbar />
      
      <main className="flex-grow mt-16">
        <HeroSection
          title="Estimation de vos métaux"
          subtitle="Obtenez rapidement une estimation pour la reprise de vos ferrailles et métaux"
          backgroundImage="/lovable-uploads/3675bbaf-3c8f-4944-bd2b-c5775eb7c06c.png"
          height="h-[300px]"
        />
        
        <section className="py-12">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="mb-10 text-center">
                <h1 className="text-3xl font-bold text-fabre-gray mb-4">
                  Demandez une estimation pour vos métaux
                </h1>
                <p className="text-lg text-gray-600">
                  Remplissez le formulaire ci-dessous pour obtenir rapidement une estimation de la valeur de vos métaux.
                  Notre équipe vous contactera dans les plus brefs délais.
                </p>
              </div>
              
              <MetalEstimationForm />
              
              <div className="mt-12 bg-gray-50 p-6 rounded-lg">
                <h3 className="text-xl font-bold text-fabre-gray mb-4">
                  Types de métaux que nous rachetons
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                  <div className="bg-white p-4 rounded shadow-sm">
                    <h4 className="font-bold mb-2">Métaux ferreux</h4>
                    <ul className="text-sm text-gray-600 space-y-1">
                      <li>• Ferraille</li>
                      <li>• Fonte</li>
                      <li>• Acier</li>
                      <li>• Fer à béton</li>
                    </ul>
                  </div>
                  <div className="bg-white p-4 rounded shadow-sm">
                    <h4 className="font-bold mb-2">Métaux non ferreux</h4>
                    <ul className="text-sm text-gray-600 space-y-1">
                      <li>• Aluminium</li>
                      <li>• Cuivre</li>
                      <li>• Laiton</li>
                      <li>• Inox</li>
                    </ul>
                  </div>
                  <div className="bg-white p-4 rounded shadow-sm">
                    <h4 className="font-bold mb-2">Autres métaux</h4>
                    <ul className="text-sm text-gray-600 space-y-1">
                      <li>• Plomb</li>
                      <li>• Zinc</li>
                      <li>• Batteries</li>
                      <li>• Câbles électriques</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default EstimationMetaux;
